import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output
} from '@angular/core';

import { Subject } from 'rxjs';

import { FooterLink } from '~app/modules/generic/models/footer-link.model';
import { ApplicationEventService } from '~shared/modules/application-event/services/application-event.service';
import { NavigationApplicationEvent } from '~shared/modules/application-event/models';
import { ApplicationNavigationEventType } from '~shared/modules/application-event/constants';

@Component({
  selector: 'app-footer-link',
  templateUrl: './footer-link.component.html',
  styleUrls: ['./footer-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterLinkComponent implements OnDestroy {
  @Input() small = false;
  @Input() separator = false;
  @Input() link: FooterLink;

  @Output() linkClicked = new EventEmitter<void>();

  private destroy$ = new Subject();

  constructor(
    private applicationEventService: ApplicationEventService
  ) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onLinkClicked(): void {
    this.applicationEventService.publish(
      new NavigationApplicationEvent(
        ApplicationNavigationEventType.FooterNavigationClick,
        this.link.trackingLabel,
        this.link.path
      )
    );

    this.linkClicked.emit();
  }
}
